import { useState, useEffect } from "react";
import moment from "moment";

const ElapsedTime = ({ startTime }) => {
    const [elapsedTime, setElapsedTime] = useState("00:00:00");

    useEffect(() => {
        if (!startTime) return;

        const updateElapsedTime = () => {
            const startMoment = moment(startTime);
            const now = moment();
            const duration = moment.duration(now.diff(startMoment));

            const days = duration.days();
            const hours = String(duration.hours()).padStart(2, "0");
            const minutes = String(duration.minutes()).padStart(2, "0");
            const seconds = String(duration.seconds()).padStart(2, "0");

            const formattedTime = days > 0 
                ? `${days}d ${hours}:${minutes}:${seconds}`
                : `${hours}:${minutes}:${seconds}`;

            setElapsedTime(formattedTime);
        };

        updateElapsedTime();  
        const interval = setInterval(updateElapsedTime, 1000);  

        return () => clearInterval(interval); 
    }, [startTime]);

    return <strong className="text-danger"> {elapsedTime}</strong>;
};

export default ElapsedTime;
